import { Image } from 'expo-image';
import { StyleSheet, View } from 'react-native';
import { Modal, Portal } from 'react-native-paper';

import { Impact } from '@/api/models/impactModels';
import { donateIcon } from '@/assets/images/icons';
import GradientCircularButton from '@/components/buttons/GradientCircularButton';
import Text from '@/components/Text';
import { formatCurrency } from '@/utils/currencyFormat';
import { i18n } from '@/utils/i18n';

import CloseButton from '../buttons/CloseButton';

interface ImpactPopUpProps {
  data: Impact;
  showPopUp: boolean;
  dismissPopUp: () => void;
}

//Components
const ImpactPopUp = ({ data, showPopUp, dismissPopUp }: ImpactPopUpProps) => {
  //Locales
  const total_donation_amount = i18n.t('profile.impact.total_donation_amount');

  if (!data) return null;

  return (
    <Portal>
      <Modal style={styles.modalStyle} visible={showPopUp} onDismiss={() => dismissPopUp()}>
        <View style={styles.popUpContainer}>
          <CloseButton onCloseTap={() => dismissPopUp()} style={styles.popUpCloseBtn} />
          <View style={styles.content}>
            <GradientCircularButton size={72}>
              <Image source={donateIcon} style={styles.donationIcon} />
            </GradientCircularButton>
            <Text style={styles.popUpTitle} fontWeight="700">
              {data.organization}
            </Text>
            <Image source={data.thumbnail} style={styles.popUpImage} />
            <Text style={styles.popUpDonationAmount} fontWeight="700">
              {formatCurrency(data.amount)}
            </Text>
            <Text style={styles.popUpSubtitle} fontWeight="450">
              {total_donation_amount}
            </Text>
          </View>
        </View>
      </Modal>
    </Portal>
  );
};

const styles = StyleSheet.create({
  modalStyle: {
    marginHorizontal: 'auto',
    alignItems: 'center'
  },

  donationIcon: {
    width: 52,
    height: 52
  },

  popUpContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingHorizontal: 10,
    paddingTop: 10,
    paddingBottom: 30,
    borderColor: '#F7BA05',
    borderWidth: 3,
    borderRadius: 10,
    backgroundColor: 'white'
  },

  content: {
    paddingHorizontal: 30,
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 10,
    alignItems: 'center'
  },

  popUpCloseBtn: {
    alignSelf: 'flex-start'
  },

  popUpTitle: {
    fontSize: 18,
    color: 'black'
  },

  popUpImage: {
    width: 90,
    height: 90,
    borderRadius: 10
  },

  popUpDonationAmount: {
    fontSize: 40,
    color: 'black'
  },

  popUpSubtitle: {
    fontSize: 14,
    color: 'black'
  }
});

export default ImpactPopUp;
